import { render, staticRenderFns } from "./grafica.vue?vue&type=template&id=94ea986e"
import script from "./grafica.vue?vue&type=script&lang=js"
export * from "./grafica.vue?vue&type=script&lang=js"
import style0 from "./grafica.vue?vue&type=style&index=0&id=94ea986e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports